<div class="justify-center items-center md:items-start flex flex-col md:flex-row gap-4">
    @if (isVisible) {
        <!-- Deck List -->
        <div class="w-[24rem] md:w-[48rem] flex flex-col">
            <div class="flex flex-col sm:flex-row" >
                <div class="flex grow font-bold p-2 min-h-8 items-center">
                    <div>{{ username }}'s Decks</div>
                </div>
                <div class="flex flex-row gap-1 sm:gap-2 items-center p-2 text-xs md:text-sm">
                    <div>
                        <select #gameSelect (change)="onGameTypeOptionSelected(gameSelect.value)" class="bg-slate-50 min-h-8 w-[10ch] md:w-[14ch] rounded-sm shadow-sm">
                            @for (game of getGameOptions() ; track game) {
                                <option [attr.value]="($index == 0 ? 'All' : game)">{{ game }}</option>
                            }
                        </select>
                    </div>
                    <div>
                        <select #deckTypeSelect (change)="onDeckTypeOptionSelected(deckTypeSelect.value)" class="bg-slate-50 min-h-8 w-[10ch] md:w-[14ch] rounded-sm shadow-sm">
                            @for (deckType of getDeckTypeOptions() ; track deckType) {
                                <option [attr.value]="($index == 0 ? 'All' : deckType)">{{ deckType }}</option>
                            }
                        </select>
                    </div>
                    @if (isOwnDecks) {
                        <div>
                            <select #visibilitySelect (change)="onVisibilityOptionSelected(visibilitySelect.value)" class="bg-slate-50 min-h-8 w-[10ch] md:w-[14ch] rounded-sm shadow-sm">
                                <option value="All">All Visibility</option>
                                <option value="Public">Public</option>
                                <option value="Friends">Friends Only</option>
                                <option value="Private">Private</option>
                            </select>
                        </div>
                        <div class="border-r border-ponder-light border-opacity-10 min-h-8 w-[1px] pl-1 mr-1">
                            
                        </div>
                        <button (click)="onCreateDeckClicked()" class="justify-center w-[12ch] flex flex-row items-center gap-1 group bg-slate-50 p-1 min-h-8 rounded-sm shadow-sm stroke-ponder-light hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:stroke-slate-500 disabled:hover:cursor-not-allowed disabled:hover:stroke-slate-500 disabled:hover:border-transparent" [disabled]="!canAddDecks" [attr.title]="canAddDecks ? undefined : 'You are at your deck limit!'">
                            <div>
                                <svg class="w-4 h-4 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                                    <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="addSvgIcon" />
                                </svg>
                            </div>
                            <div>New</div>
                        </button>
                        <button (click)="onImportDeckClicked()" class="justify-center w-[12ch] flex flex-row items-center gap-1 group bg-slate-50 p-1 min-h-8 rounded-sm shadow-sm stroke-ponder-light hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-500 disabled:stroke-slate-500 disabled:hover:cursor-not-allowed disabled:hover:stroke-slate-500 disabled:hover:border-transparent" [disabled]="!canAddDecks">
                            <div>
                                <svg class="w-4 h-4 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                                    <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="importSvgIcon" />
                                </svg>
                            </div>
                            <div>Import</div>
                        </button>
                    }
                </div>
            </div>
            <div class="flex flex-row justify-end border-t border-ponder-light border-opacity-10 text-xs pt-1 pr-2">
                @if (!isLoading && isOwnDecks) {
                    <div [ngClass]="{ 'text-red-700' : !canAddDecks, 'text-slate-600' : canAddDecks }">{{ totalDecks }} / {{ userDeckLimit }} Decks</div>
                }
            </div>
            <loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>
            <div class="flex flex-col">
                @for (deckGroupRef of deckGroups ; track deckGroupRef.group) {
                    @if (deckGroupRef.decks.length) {
                        <deck-preview-group [userDeckComponentRef]="this" [name]="deckGroupRef.group" [decks]="deckGroupRef.decks"></deck-preview-group>
                    }
                }
            </div>
        </div>
    } @else if (isVisible == false) {
        <unauthorized [authSession]="authSession"></unauthorized>
    }
</div>
<deck-create-modal></deck-create-modal>
<deck-import-modal></deck-import-modal>